var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TextBlock flex flex-col wrapper-3 spacer-bottom-3"},[_c('RichText',{attrs:{"field":_vm.body,"className":"TextBlock__text subheading"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }